import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../Utility";

export const initialState = {
  loading: false,
  error: null,
  data: [],
  message: null,
  page: null,
  loadedPages: [],
  hasMore: true,
  queryListTimestamp: null,
  queryDetail: null,
  queryDetailLoading: false,
  queryDetailError: null,
  addEditError: null,
  addEditSuccess: null,
  addEditLoading: false,
  redirectTo: null,
  queryCategoryList: [],
};

const queryListStart = (state, action) => {
  return updateObject(state, {
    loading: true,
    error: null,
    message: null,
    redirectTo: null,
  });
};

const queryListFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    data: [],
    message: null,
    redirectTo: null,
    loadedPages: [],
    hasMore: true,
  });
};

const queryListing = (state, action) => {
  const safeData = Array.isArray(action.data) ? action.data : [];

  return updateObject(state, {
    loading: false,
    error: null,
    data: safeData,
    filterData: safeData,

    totalRecords: action.totalRecords,
    currentPage: action.currentPage,
    totalPages: action.totalPages,
    limit: action.limit,
    count: action.count,

    message: action.message,
    page: action.page,
    queryListTimestamp: action.timestamp || Date.now(),
    queryDetailError: null,
    queryDetail: null,
    redirectTo: null,
  });
};

const queryDetailStart = (state, action) => {
  return updateObject(state, {
    queryDetailLoading: true,
    queryDetailError: null,
  });
};

const queryDetailSuccess = (state, action) => {
  let detailData = action.data;

  if (action.data && action.data.data !== undefined) {
    detailData = action.data.data;
  }

  return updateObject(state, {
    queryDetailLoading: false,
    queryDetail: detailData,
    queryDetailError: null,
  });
};

const queryDetailFail = (state, action) => {
  return updateObject(state, {
    queryDetailLoading: false,
    queryDetail: null,
    queryDetailError: action.error,
  });
};

const addEditSuccess = (state, action) => {
  return updateObject(state, {
    addEditSuccess: action.message,
    redirectTo: action.redirectTo,
    addEditLoading: false,
  });
};

const addEditFail = (state, action) => {
  return updateObject(state, {
    addEditError: action.error,
    addEditLoading: false,
  });
};

const addEditStart = (state, action) => {
  return updateObject(state, {
    addEditError: null,
    addEditSuccess: null,
    addEditLoading: true,
  });
};

const filterList = (state, action) => {
  const filterText = (action.text || "").toLowerCase();
  const filteredItems = state.data.filter((item) => {
    return item.Reference && item.Reference.toLowerCase().includes(filterText);
  });
  return updateObject(state, { data: filteredItems });
};

// New reducer functions for updateQueryLineItem
const updateQueryLineItemStart = (state, action) => {
  return updateObject(state, {
    queryDetailLoading: true,
    queryDetailError: null,
  });
};

const updateQueryLineItemSuccess = (state, action) => {
  let updatedData = action.data;

  if (action.data && action.data.data !== undefined) {
    updatedData = action.data.data;
  }

  return updateObject(state, {
    queryDetailLoading: false,
    queryDetail: updatedData,
    queryDetailError: null,
  });
};

const updateQueryLineItemFail = (state, action) => {
  return updateObject(state, {
    queryDetailLoading: false,
    queryDetailError: action.error,
  });
};

const updateQueryDetailsStart = (state, action) => {
  return updateObject(state, {
    queryDetailLoading: true,
    queryDetailError: null,
  });
};

const updateQueryDetailsSuccess = (state, action) => {
  let updatedData = action.data;

  if (action.data && action.data.data !== undefined) {
    updatedData = action.data.data;
  }

  return updateObject(state, {
    queryDetailLoading: false,
    queryDetail: updatedData,
    queryDetailError: null,
  });
};

const updateQueryDetailsFail = (state, action) => {
  return updateObject(state, {
    queryDetailLoading: false,
    queryDetailError: action.error,
  });
};

const queryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.QUERY_LIST_START:
      return queryListStart(state, action);

    case actionTypes.QUERY_LIST_SUCCESS:
      const newState = queryListing(state, action);
      return newState;

    case actionTypes.QUERY_LIST_FAIL:
      return queryListFail(state, action);

      default:
      return state;
  }
};

export default queryReducer;
